/* unplugin-vue-components disabled */import { render } from "./MyTable.vue?vue&type=template&id=899fffea"
import script from "./MyTable.vue?vue&type=script&lang=js"
export * from "./MyTable.vue?vue&type=script&lang=js"

import "./MyTable.vue?vue&type=style&index=0&id=899fffea&lang=scss"

import exportComponent from "D:\\Project\\Juanfu\\CBK定制版\\hcontrol_download\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__